import Commander from "./Commander";
import {pixiSetTimeout} from "../framework/src/engine/pixi/pixiTimeout";

export default class BlinkAnimation {

    constructor (commander) {
        this.commander = commander;

        this.targets = [];   // idle win symbols and normal wins
        this.wildTargets = []; // only for sticky wild symbols
        this.filter = new PIXI.filters.ColorMatrixFilter();
        this.tween = {
            brightness: 1
        };

        this.brightness = {
            max: 2,
            min: 1
        };

        this.jokers = new PIXI.Container();
    }

    init() {
        this.NormalWin = this.commander.NormalWin;
        this.frames = this.NormalWin.frames;



        this.run();
        this.commander.layers.win.addChildAt(this.jokers,0);
    }

    run() {
        createjs.Tween.get(this.tween, {loop: true})
            .to({brightness: this.brightness.max}, 150)
            .to({brightness: this.brightness.min}, 150)
            .addEventListener('change', () => {
                this.filter.brightness(this.tween.brightness, false);
            });
    }

    blinkFrames() {
        this.frames.filters = [this.filter];
    }

    setTargets(array) {
        for (let item of array)
            this.addTarget(item);
    }

    addTarget(item, type = 0) {
        if (!item) return
        if (item.name.replace("_blur","") === "symbol_Joker") {
            let rect = BlinkAnimation.getRect(item.x, item.y);
            rect.filters = [this.filter];
            this.jokers.addChild(rect);

            this.itemPush(rect, type);
        } else {
            item.filters = [this.filter];
            this.itemPush(item, type);
        }
    }

    itemPush(item, type) {
        if (type === "wild") {
            item.flag = true;
            this.wildTargets.push(item);
        } else {
            this.targets.push(item);
        }
    }

    clearTargetFilters() {
        for (let item of this.targets) {
            if (item.flag !== true)
                item.filters = [];
        }
        this.targets = [];
        this.jokers.removeChildren();
    }

    clearWildFilters() {
        for (let item of this.wildTargets) {
            item.filters = [];
        }
        this.wildTargets = [];
        this.jokers.removeChildren();

    }

    blinkStar(star) {
        star.filters = [this.filter];
        pixiSetTimeout(.5, () => {
            if (this.commander.starCount !== 3) {
                star.filters = [];
            }
        });
    }

    static getRect(x, y) {
        let rect = new PIXI.Graphics();
        rect.beginFill(0xFFFFFF);
        rect.lineStyle(0,0xFFFFFF, 1);
        rect.drawRect(x,y+35, 210, 130);
        rect.endFill();
        rect.alpha = .3;
        rect.pivot.set(105, 100);
        return rect;
    }
}